import { ContainerModule } from 'inversify';
import { SearchService, SearchServiceSymbol } from '@/app/search/search-service';

export const searchModule = new ContainerModule((bind) => {
  bind<SearchService>(SearchServiceSymbol).to(SearchService).inSingletonScope();
});
